export default "__VITE_ASSET__D$Noxqzs__"